// Système de traductions FR/EN pour MECA-GTECH

export const translations = {
  fr: {
    // Header
    home: 'Accueil',
    services: 'Services',
    achievements: 'Réalisations',
    contact: 'Contact',
    
    // Hero Home
    heroHomeTitle: 'Spécialiste en moteurs diesel industriels',
    heroHomeSubtitle: 'Expertise en diagnostic, réparation et maintenance de moteurs diesel',
    
    // Hero Services
    heroServicesTitle: 'Services',
    heroServicesSubtitle: 'Découvrez l\'ensemble des prestations que nous proposons.',
    
    // Hero Achievements
    heroAchievementsTitle: 'Nos Réalisations',
    heroAchievementsSubtitle: 'Découvrez nos succès et les projets qui ont marqué notre parcours',
    
    // Home - Présentation
    presentationTitle: 'Votre Expert en Moteurs Diesel Industriels',
    presentationText: 'MECA-GTECH est spécialisée dans la maintenance, la réparation et le dépannage de moteurs diesel industriels. Nous intervenons sur site ou en atelier pour garantir le bon fonctionnement de vos équipements, réduire vos arrêts de production et prolonger la durée de vie vos machines.',
    
    // Features
    performance: 'Performance',
    performanceDesc: 'Intervention rapide sur site pour la réparation et le diagnostic des moteurs diesel industriels',
    reliability: 'Fiabilité',
    reliabilityDesc: 'Garantie du respect des normes de sécurité, de qualité et de traçabilité',
    expertise: 'Expertise',
    expertiseDesc: 'Une équipe de techniciens qualifiés et expérimentés à votre service (+ de 20 ans d\'expérience)',
    
    // Services
    ourServices: 'Nos Services',
    diagnosticTechnique: 'Diagnostic Technique',
    diagnosticDesc: 'Enquête technique sur les symptômes et identifier rapidement les problèmes.',
    expertiseService: 'Expertise',
    expertiseServiceDesc: 'Bilans de l\'état de vos composants internes et externes.',
    reparation: 'Réparation',
    reparationDesc: 'Restaurer les performances d\'origine : moteur complet, injecteurs, turbo, joints, pompes, etc...',
    revision: 'Révision complète & Reconditionnement',
    revisionDesc: 'Offrir les mêmes garanties fonctionnelles que l\'origine, réduire les coûts et les délais.',
    maintenance: 'Maintenance Industrielle',
    maintenanceDesc: 'Suivi et entretien préventif de vos moteurs diesel pour les engins de chantier, groupes électrogènes et machines industrielles.',
    contrats: 'Contrats d\'entretien',
    contratsDesc: 'Assurer la continuité de service, réduire les coûts de maintenance et maximiser la durée de vie de vos moteurs.',
    
    // About
    aboutTitle: 'À Propos de MECA-GTECH',
    ourHistory: 'Notre Histoire',
    historyText1: 'Une passion pour la mécanique, un engagement pour la performance industrielle.',
    historyText2: 'Fondée en 2025 par 2 frères, MECA-GTECH est née d\'une volonté claire: offrir aux professionnels un service de maintenance et de réparation mécanique fiable, réactif et spécialisé dans les moteurs diesel industriels.',
    historyText3: 'Notre entreprise intervient partout dans le monde, avec une capacité d\'intervention rapide et un niveau d\'exigence constant.',
    
    // Footer
    contactUs: 'Nous contacter',
    followLinkedIn: 'Suivez-nous sur LinkedIn',
    viewOnMap: 'Voir sur OpenStreetMap',
    ourWorkshop: 'Notre atelier est ici',
    legalNotice: 'Mentions légales',
    siteMap: 'Plan du site',
    realisations: 'Réalisation',
    
    // Achievements
    readyProject: 'Prêt à concrétiser votre projet ?',
    joinClients: 'Rejoignez nos nombreux clients satisfaits et faites confiance à notre expertise.',
    contactButton: 'Contactez-nous',
    project: 'Projet',
    
    // Common
    soonAvailable: 'Bientôt disponible'
  },
  
  en: {
    // Header
    home: 'Home',
    services: 'Services',
    achievements: 'Achievements',
    contact: 'Contact',
    
    // Hero Home
    heroHomeTitle: 'Industrial Diesel Engine Specialist',
    heroHomeSubtitle: 'Expertise in diagnosis, repair and maintenance of diesel engines',
    
    // Hero Services
    heroServicesTitle: 'Services',
    heroServicesSubtitle: 'Discover the full range of services we offer.',
    
    // Hero Achievements
    heroAchievementsTitle: 'Our Achievements',
    heroAchievementsSubtitle: 'Discover our successes and the projects that have marked our journey',
    
    // Home - Presentation
    presentationTitle: 'Your Expert in Industrial Diesel Engines',
    presentationText: 'MECA-GTECH specializes in the maintenance, repair and troubleshooting of industrial diesel engines. We work on site or in our workshop to ensure the proper functioning of your equipment, reduce your production downtime and extend the life of your machines.',
    
    // Features
    performance: 'Performance',
    performanceDesc: 'Rapid on-site intervention for repair and diagnosis of industrial diesel engines',
    reliability: 'Reliability',
    reliabilityDesc: 'Guarantee of compliance with safety, quality and traceability standards',
    expertise: 'Expertise',
    expertiseDesc: 'A team of qualified and experienced technicians at your service (20+ years of experience)',
    
    // Services
    ourServices: 'Our Services',
    diagnosticTechnique: 'Technical Diagnosis',
    diagnosticDesc: 'Technical investigation of symptoms and rapid problem identification.',
    expertiseService: 'Expertise',
    expertiseServiceDesc: 'Assessment of your internal and external components condition.',
    reparation: 'Repair',
    reparationDesc: 'Restore original performance: complete engine, injectors, turbo, gaskets, pumps, etc...',
    revision: 'Complete Overhaul & Reconditioning',
    revisionDesc: 'Offer the same functional guarantees as original, reduce costs and lead times.',
    maintenance: 'Industrial Maintenance',
    maintenanceDesc: 'Monitoring and preventive maintenance of your diesel engines for construction equipment, generators and industrial machines.',
    contrats: 'Maintenance Contracts',
    contratsDesc: 'Ensure service continuity, reduce maintenance costs and maximize engine lifespan.',
    
    // About
    aboutTitle: 'About MECA-GTECH',
    ourHistory: 'Our History',
    historyText1: 'A passion for mechanics, a commitment to industrial performance.',
    historyText2: 'Founded in 2025 by 2 brothers, MECA-GTECH was born from a clear desire: to offer professionals a reliable, responsive mechanical maintenance and repair service specialized in industrial diesel engines.',
    historyText3: 'Our company operates worldwide, with rapid intervention capacity and constant level of excellence.',
    
    // Footer
    contactUs: 'Contact us',
    followLinkedIn: 'Follow us on LinkedIn',
    viewOnMap: 'View on OpenStreetMap',
    ourWorkshop: 'Our workshop is here',
    legalNotice: 'Legal Notice',
    siteMap: 'Site Map',
    realisations: 'Achievements',
    
    // Achievements
    readyProject: 'Ready to realize your project?',
    joinClients: 'Join our many satisfied customers and trust our expertise.',
    contactButton: 'Contact us',
    project: 'Project',
    
    // Common
    soonAvailable: 'Soon available'
  }
};

// Hook personnalisé pour utiliser les traductions
export const useTranslation = (lang) => {
  return (key) => {
    return translations[lang]?.[key] || translations.fr[key] || key;
  };
};